import { useState } from "react";
import { rankList } from "@/mocks/dramaData";

const medals = ["bg-secondary-400", "bg-background-300", "bg-accent-600"];

export default function RankSection() {
  const [mode, setMode] = useState<"all" | "hot">("all");
  const list =
    mode === "hot"
      ? rankList.filter((r) => r.delta.startsWith("+"))
      : rankList;

  return (
    <section id="rank" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-end">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800">
              <i className="ri-fire-fill"></i> 本月大瓜榜单
            </span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              本月实时热度 Top 榜
            </h2>
            <p className="mt-3 max-w-2xl text-sm text-foreground-700 md:text-base">
              综合多平台热搜与讨论量加权的实时排名，热度条一眼看懂差距。
            </p>
          </div>

          <div className="inline-flex items-center gap-1 rounded-full bg-background-50 p-1 ring-1 ring-background-200">
            <button
              onClick={() => setMode("all")}
              className={`whitespace-nowrap rounded-full px-5 py-2 text-xs font-semibold transition cursor-pointer ${
                mode === "all" ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              综合热度
            </button>
            <button
              onClick={() => setMode("hot")}
              className={`whitespace-nowrap rounded-full px-5 py-2 text-xs font-semibold transition cursor-pointer ${
                mode === "hot" ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              今日飙升
            </button>
          </div>
        </div>

        <ol className="mt-10 flex flex-col gap-3">
          {list.map((item, idx) => {
            const top3 = item.rank <= 3;
            const up = item.delta.startsWith("+");
            const down = item.delta.startsWith("-");
            return (
              <li
                key={item.title}
                className={`flex flex-col gap-3 rounded-2xl border p-4 transition hover:-translate-y-0.5 md:flex-row md:items-center md:p-5 ${
                  top3
                    ? "border-primary-200 bg-background-50 shadow-sm"
                    : "border-background-200 bg-background-50"
                }`}
              >
                <div className="flex items-center gap-3 md:w-16 md:shrink-0">
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-black text-background-50 ${
                      top3 ? medals[item.rank - 1] : "bg-background-300 text-foreground-800"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-semibold text-secondary-900 md:hidden">
                    {item.tag}
                  </span>
                </div>

                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <a href="#featured" className="cursor-pointer text-sm font-bold text-foreground-950 hover:text-primary-700 md:text-base">
                      {item.title}
                    </a>
                    <span className="hidden whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-semibold text-secondary-900 md:inline-block">
                      {item.tag}
                    </span>
                  </div>
                  <div className="mt-2 flex items-center gap-3">
                    <div className="h-1.5 flex-1 max-w-md overflow-hidden rounded-full bg-background-200">
                      <div
                        className={`h-full rounded-full ${top3 ? "bg-primary-500" : "bg-accent-500"}`}
                        style={{ width: `${item.heat}%` }}
                      ></div>
                    </div>
                    <span className="whitespace-nowrap text-xs text-foreground-500">热度 {item.heat} 万</span>
                  </div>
                </div>

                <div className="flex items-center gap-2 md:flex-col md:items-end md:gap-1">
                  <span
                    className={`inline-flex items-center gap-0.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold ${
                      up
                        ? "bg-accent-100 text-accent-700"
                        : down
                        ? "bg-background-200 text-foreground-600"
                        : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    {up ? (
                      <i className="ri-arrow-up-line"></i>
                    ) : down ? (
                      <i className="ri-arrow-down-line"></i>
                    ) : (
                      <i className="ri-loader-3-line"></i>
                    )}
                    {up || down ? `上升 ${item.delta.replace(/\+|-/g, "")} 位` : "持平"}
                  </span>
                  <span className="hidden whitespace-nowrap text-[11px] text-foreground-400 md:inline">
                    {item.period}
                  </span>
                </div>
              </li>
            );
          })}
        </ol>

        <p className="mt-6 text-center text-xs text-foreground-500">
          榜单每 6 小时刷新 · 数据为平台聚合演示值，仅作展示
        </p>
      </div>
    </section>
  );
}